import Axios from "axios";
import config from "../app.config";

let notificationsForSysService;
export default notificationsForSysService = {
    getNotificationsForSys,
    updateNotificationsForSys,
    createNotificationsForSys,
    searchNotificationsForSys,
    deleteAllSelectNotificationsForSys,
    readAllSelectNotificationsForSys,
    createReadNotificationsForSys,
    countUnreadNotificationForSys,
}

async function searchNotificationsForSys(payload) {
    return await Axios.get(`${config.LOCAL_API_URL}/notifications-system/search`, { params: payload })
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error);
        })
}
async function getNotificationsForSys(id) {
    return await Axios.get(`${config.LOCAL_API_URL}/notifications-system/` + id)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
async function updateNotificationsForSys(data) {
    return await Axios.put(`${config.LOCAL_API_URL}/notifications-system/` + data.id, data)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
async function deleteAllSelectNotificationsForSys(params) {
    return await Axios.put(`${config.LOCAL_API_URL}/delete-all-select-notifications-system`, { data: params })
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
async function readAllSelectNotificationsForSys(params) {
    return await Axios.post(`${config.LOCAL_API_URL}/read-all-select-notifications-system`, { data: params })
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
async function createNotificationsForSys(params) {
    return await Axios.post(`${config.LOCAL_API_URL}/notifications-system`, params)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
async function createReadNotificationsForSys(params) {
    return await Axios.post(`${config.LOCAL_API_URL}/read-notifications-system`, params)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}
async function countUnreadNotificationForSys() {
    return await Axios.get(`${config.LOCAL_API_URL}/count-unread-notifications`)
        .then(response => {
            if (response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error => {
            return Promise.reject(error.response.data);
        })
}